import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { Alert, AlertTitle, alpha, Button } from '@mui/material';
import { useCallbacks, usePartial } from 'shared/hooks/utils';
import { rejectUiLearning, startUILearning } from 'console/ui-guide/redux/actions';
import { close_left_menu } from 'console/redux/settings-actions';
import { needShowSomeGuide, uiGuideForShow } from 'console/ui-guide/suggestion/utils';
import branding from 'shared/app/model/branding';
export function SuggestionForLearningDialog() {
    const show = useAppSelector(needShowSomeGuide);
    if (!show || !branding.guide_tour) {
        return null;
    }
    return _jsx(SuggestionForLearningDialogForGuide, {});
}
function SuggestionForLearningDialogForGuide() {
    const ui_guide = useAppSelector(uiGuideForShow);
    if (!ui_guide) {
        return null;
    }
    return _jsx(SuggestionForLearningDialogImpl, { ui_guide: ui_guide });
}
function SuggestionForLearningDialogImpl(props) {
    const { ui_guide } = props;
    const start_learning = useCallbacks([
        useAction(close_left_menu),
        usePartial(useAction(startUILearning), ui_guide.id),
    ]);
    const reject = usePartial(useAction(rejectUiLearning), ui_guide.id);
    return (_jsx(ErrorBoundary, { children: _jsxs(Alert, { severity: "info", variant: "filled", onClose: reject, children: [_jsxs(AlertTitle, { children: ["\u0416\u0435\u043B\u0430\u0435\u0442\u0435 \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C ", ui_guide.name, "?"] }), _jsx(Button, { onClick: start_learning, variant: "outlined", fullWidth: true, sx: (theme) => ({
                        color: theme.palette.common.white,
                        border: `1px solid ${theme.palette.common.white}`,
                        '&:hover, &.Mui-focusVisible': {
                            border: `1px solid ${theme.palette.common.white}`,
                            backgroundColor: alpha(theme.palette.common.white, 0.1),
                        },
                    }), children: "\u041F\u0440\u043E\u0439\u0442\u0438 \u043E\u0431\u0443\u0447\u0435\u043D\u0438\u0435" })] }) }));
}
